import { TableSkeleton } from "@hiya/ui";
import { CenteredMessage } from "./CenteredMessage";

export function LoadingState({ columns }: { columns: number }) {
  return <TableSkeleton columns={columns} />;
}

export function ErrorState({ message }: { message: string }) {
  return <CenteredMessage message={message} />;
}

export function EmptyState({ message }: { message: string }) {
  return <CenteredMessage message={message} />;
}

interface DataTableProps {
  columns: readonly string[];
  children: React.ReactNode;
}

export function DataTable({ columns, children }: DataTableProps) {
  return (
    <div className="border border-stroke-primary rounded-xl overflow-hidden">
      <table className="w-full">
        <thead>
          <tr className="bg-bg-tertiary border-b border-stroke-primary">
            {columns.map((col) => (
              <th
                key={col}
                className={`p-4 text-sm font-medium text-text-tertiary text-left ${col === "Actions" ? "text-center w-[200px]" : ""}`}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
